
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import RefreshButton from '../Utility/Components/RefreshButton';
import CustomNoRowsOverlay from '../Utility/Components/CustomNoRowsOverlay';
import './Assets/css/supportUserdoc.scss';
import CustomButton from '../Utility/Components/CustomButton';
import AutosuggestComponent from '../Utility/Components/AutosuggestComponent';
import { DebounceInput } from 'react-debounce-input';
import ModalGlobal from '../Utility/Components/ModalGlobal';
import ErrorBoundary from '../Utility/Components/ErrorBoundary';
import AddSupportUserModalContent from './Components/AddSupportUserModalContent';
import PopoverStickOnHover from '../Utility/Components/PopoverStickOnHover';
import Utility from '../Utility/Utility';
import ConfirmationAlert from '../Utility/Components/ConfirmationAlert';
import GridActionContent from '../Utility/Components/GridActionContent';
import ViewBusinessDetailsModalContent from './Components/ViewBusinessDetailsModalContent';
import AuditHistoryModalContent from './Components/AuditHistoryModalContent';
import { supportUserList, supportUserUpdate } from './Controller/SupportUserController';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../Actions/AllAction';

function SupportUser(props) {
    const history = useHistory();
    const [modules, setmodules] = useState([InfiniteRowModelModule]);
    const [defaultColDef, setdefaultColDef] = useState({
        flex: 1,
        minWidth: 50

    });

    const [components, setcomponents] = useState({
        loadingRenderer: (params) => {
            if (params.value !== undefined) {
                return params.value;
            } else {
                return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
            }
        },
    })

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridparams, setgridparams] = useState(null);
    const [isAnimating, setIsAnimating] = useState(true);

    const [columnDefs, setColumnDefs] = useState(
        [
            {
                headerName: "",
                field: "amenity_icon",
                maxWidth: 72,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params && params.data) {
                        if (params.data && params.data.profile_img_url) {
                            let parseImageUrl = JSON.parse(params.data.profile_img_url);
                            return <div className="gridusericon">
                                <img src={parseImageUrl.img_url} />
                            </div>
                        } else {
                            return <div className="gridusericon">
                                <img src={require('../Utility/Public/images/no-icon.png')} />
                            </div>
                        }
                    } else {
                        return null
                    }
                }
            },
            {
                headerName: 'Name',
                field: "name",
                minWidth: 250,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        let concatname = params.data.first_name + "" + params.data.last_name
                        if (params.data.first_name && params.data.first_name && concatname.length > 15) {
                            return <div><span className="textrenderview">
                                <OverlayTrigger overlay={<Tooltip>{params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}</Tooltip>}>
                                    <span >
                                        {params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}
                                    </span>
                                </OverlayTrigger>
                            </span></div>
                        } else {
                            return (<div><span className="textrenderview">{params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}</span></div>)
                        }

                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Email',
                field: "email",
                minWidth: 250,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        const email = params.data.email ? params.data.email.split('#')[0] : '';
                        if (email && email.length > 20) {
                            return <div><span className="textrenderview">
                                <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip>{email}</Tooltip>}>
                                    <span >{email}</span>
                                </OverlayTrigger>
                            </span></div>
                        } else {
                            return <div><span className="textnowrapview">{email}</span></div>
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Phone Number',
                field: "contact_number",
                minWidth: 250,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        const contactNumber = params.data.contact_number ? params.data.contact_number.split('#')[0] : '';
                        if (contactNumber) {
                            return <div><span >{contactNumber}</span></div>
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: "Status",
                field: "is_active",
                minWidth: 100,
                suppressMovable: true,
                cellClass: 'switchBtn-custom-class',
                cellRenderer: (params) => {
                    if (params) {
                        if (params.data) {
                            return <button className="switchBtn switchBtnSupportUser">
                                <div className="switchCustomizeBtn">
                                    <BootstrapSwitchButton checked={params.data && params.data.is_active ? params.data.is_active : false}
                                        onChange={() => handleChangeSwitchButton(params.data)}
                                        onlabel='Active'
                                        onstyle='success'
                                        offlabel='Inactive'
                                        offstyle='danger'
                                        style='w-100 mx-3'
                                    />
                                </div>
                            </button>
                        } else {
                            return null
                        }
                    } else {
                        return null
                    }
                },
            },
            {
                headerName: "Assigned Business",
                field: "members",
                minWidth: 250,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        const { hotel_count, agency_count } = params.data;
                        const { UserOrgBranchRoleRelation } = params.data;
                        return (
                            <div className="businessNameList">
                                <div className="imgcountlabel businessListNameBox">
                                    <ul className='businessNameBox'>
                                        {UserOrgBranchRoleRelation && UserOrgBranchRoleRelation.length > 0 && <li><span className='hotelCount'>{UserOrgBranchRoleRelation.length} {Number(UserOrgBranchRoleRelation.length) > 1 ? 'Organizations' : 'Organization'}</span></li>}
                                        {/* {Number(agency_count) > 0 && <li><span className='agencyCount'>{agency_count} {Number(agency_count) > 1 ? 'Agencies' : 'Agency'}</span></li>} */}
                                    </ul>
                                    <OverlayTrigger overlay={<Tooltip>{'View'}</Tooltip>}>
                                        <span className='viewBusinessList' onClick={() => detailsViewModalfunction(params.data)}> <i className="fa fa-eye"></i></span>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        );
                    } else {
                        return null;
                    }
                }
            },
            {
                headerName: "",
                field: "edit",
                width: 90,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        return <div className="actionablePopupBox">
                            {params.data.is_active &&
                                <button className="ellipsisIcon" onClick={(e) => actionModalfunction(e, params)}><i className="fa fa-ellipsis-v"></i></button>
                            }
                        </div>
                    } else {
                        return null;
                    }
                },
            }

        ]
    )

    const actionOutsideClickRef = useRef();
    const [searchUserName, setSearchUserName] = useState("");
    const [actionModalflag, setActionModalflag] = useState(false);
    const [overlayHight, setOverlayHight] = useState(0);
    const [overlayWidth, setOverlayWidth] = useState(0);
    const [gridObjData, setGridObjData] = useState({});
    const [selectedStatus, setSelectedStatus] = useState("");
    const [statusList, setStatusList] = useState([
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
    ]);
    const gridRef = useRef();
    const [supportUserCreateModalFlag, setSupportUserCreateModalFlag] = useState(false);
    const [auditHistoryModalFlag, setAuditHistoryModalFlag] = useState(false);
    // //Edite flags
    const [editedUserFlag, setEditedUserFlag] = useState(false);
    const [editRowData, setEditRowData] = useState({});
    const [zoominzoomoutflag, setZoominzoomoutflag] = useState("");
    const [supportUserModalTitle, setSupportUserModalTitle] = useState("");
    const [supportUserId, setSupportUserId] = useState("");
    const [viewBusnessListModal, setViewBusnessListModal] = useState(false);
    // //delete flag
    const [deleteConfirmationAlertModal, setDeleteConfirmationAlertModal] = useState(false);
    const [deleteBodySecondContent, setDeleteBodySecondContent] = useState("");
    const [hotelDeleteObj, setHotelDeleteObj] = useState({});



    //agrid gridready fn
    const onGridReady = useCallback((params) => {
        setgridparams(params)
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        var datasource = serverSideDataSource()
        params.api.setDatasource(datasource);
    });

    //reset aggrid data fn 
    const resetDataGrid = () => {
        var datasource = serverSideDataSource()
        gridApi.setDatasource(datasource);
    }

    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);

    //serverside support user list fn
    const serverSideDataSource = () => {
        return {
            getRows(params) {
                const { startRow, endRow, filterModel, sortModel } = params
                const { loaderStateTrue, loaderStateFalse } = props;
                loaderStateTrue();
                setIsAnimating(true);
                let filters = {};
                let filter_op = {};
                let globalQueryParamshash = {};

                globalQueryParamshash["offset"] = startRow;
                globalQueryParamshash["limit"] = 10;
                globalQueryParamshash["user_type"] = "support_user";

                if (searchUserName != "") {
                    globalQueryParamshash['search_attr'] = searchUserName
                    filter_op = Object.assign(filter_op, { "search_attr": "substring" });
                }

                if (selectedStatus != "") {
                    globalQueryParamshash['is_active'] = selectedStatus.value == "active" ? true : false;
                }
                if (Object.keys(filter_op).length > 0) {
                    filters["filter_op"] = JSON.stringify(filter_op);
                }
                filters['filters'] = JSON.stringify(globalQueryParamshash)
                supportUserList(filters).then((response) => {
                    if (response.success) {
                        if (response.data.length == 0 && startRow == 0) {
                            gridRef.current.api.showNoRowsOverlay();
                        } else {
                            gridRef.current.api.hideOverlay();
                        }
                        params.successCallback(response.data, response.total);
                        loaderStateFalse();
                        setIsAnimating(false);
                    } else {
                        console.error(error);
                        params.failCallback();
                        Utility.toastNotifications("Something went wrong !", "Error", "error")
                        loaderStateFalse();
                        setIsAnimating(false);
                    }

                }).catch((error) => {
                    console.error("************error*************", error)
                    if (error) {
                    }
                    loaderStateFalse();
                    setIsAnimating(false);
                    if (error.message == "Network Error") {

                    }
                });
            }
        };
    }

    //support user grid option for aggrid
    const gridOptions = useMemo(
        () => ({
            infiniteInitialRowCount: 1,
            paginationPageSize: 100,
            rowBuffer: 0,
            rowModelType: 'infinite',
            suppressCellSelection: true,
            suppressHorizontalScroll: true,
        }),
        []
    )

    //view support user's business fn
    const detailsViewModalfunction = (obj) => {
        setSupportUserId(obj.id);
        setViewBusnessListModal(true);
    }

    //support user search filter
    const handleSearchValue = (e) => {
        setSearchUserName(e.target.value)
    }

    //afer change support user search filter
    useEffect(() => {
        if (searchUserName != "") {
            resetDataGrid()
        }
        if (searchUserName.length == 0 && gridparams) {
            resetDataGrid()
        }
    }, [searchUserName])

    //clear support user search filter
    const clearSearchValue = () => {
        setSearchUserName("")
        resetDataGrid()
    }

    //support user grid action modal outside close fn
    useEffect(() => {
        const handleMouseDown = (event) => {
            handleClickOutside(event);
        };
        document.body.addEventListener('mousedown', handleMouseDown);

        return () => {
            document.body.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);

    //support user grid action button click fn
    const actionModalfunction = (e, gridObj) => {
        e.stopPropagation();
        let width = (parseInt(e.clientX) - 200) + 'px';
        let height = (parseInt(e.clientY) - 60) + 'px';
        setActionModalflag(true);
        setOverlayHight(height);
        setOverlayWidth(width);
        setGridObjData(gridObj);

    }

    //action modal outside close fn
    const handleClickOutside = (event) => {
        if (actionOutsideClickRef.current && !actionOutsideClickRef.current.contains(event.target)) {
            setActionModalflag(false);
            setOverlayHight(0);
            setOverlayWidth(0);
        }
    };

    //support user aggrid refresh data load
    const loadGrid = () => {
        resetDataGrid();
    }

    //support user edit fn
    const editSupportUserFn = (data) => {
        if (data.data && data.data.is_active) {
            setEditRowData(data.data)
            setEditedUserFlag(true)
            setSupportUserCreateModalFlag(true);
            setSupportUserModalTitle("Edit Support User")
        } else {
            Utility.toastNotifications("The user's current status is inactive. Alter the user's status if you wish to make any changes to it.", "Warning", "warning")
        }
    }

    //active inactive swich button change functionality
    const handleChangeSwitchButton = (data) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let dataHash = {};
        let id = data.id
        dataHash["is_active"] = data.is_active ? false : true;
        loaderStateTrue()
        supportUserUpdate(dataHash, id).then((response) => {
            if (response) {
                if (response.success) {
                    gridOptions.api.purgeInfiniteCache();
                    Utility.toastNotifications(response.message, "Success", "success");
                    resetDataGrid();
                } else {
                    gridOptions.api.purgeInfiniteCache();
                    Utility.toastNotifications(response.message, "Error", "error");
                    resetDataGrid();
                }
                loaderStateFalse()
            }
        }).catch((error) => {
            if (error) {
            }
            loaderStateFalse();
            gridOptions.api.purgeInfiniteCache();
            if (error.message == "Network Error") {
            }
        });
    }

    //active-inacive filter onchange fn
    const handleChangeUserFilter = (type, event) => {
        if (type == 'status') {
            if (event) {
                setSelectedStatus(event)
            } else {
                setSelectedStatus("")
            }
        }
    }

    //changing status , reset data
    useEffect(() => {
        if (gridApi && selectedStatus != "" && selectedStatus.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && selectedStatus == "") {
            resetDataGrid();
        }
    }, [selectedStatus])

    //create support user modal fn
    const createSupportUserModalFn = () => {
        setSupportUserCreateModalFlag(true);
        setSupportUserModalTitle("Add Support User")
    }

    //close support user modal fn
    const closeSupportUserModal = (success = false) => {
        setSupportUserCreateModalFlag(false);
        setEditedUserFlag(false)
        setEditRowData({})
        setZoominzoomoutflag("")
        if (success) {
            resetDataGrid();
        }
    }

    //open audit history modal fn
    const auditHistoryModalFn = () => {
        setAuditHistoryModalFlag(true);

    }

    //audit history modal close fn
    const auditHistoryModalHide = () => {
        setAuditHistoryModalFlag(false);
        setSupportUserId('');
    }


    //zoomin modal fn
    const zoominFunction = () => {
        let zoominzoomoutflag = "zoominzoomoutclassSupportUser"
        setZoominzoomoutflag(zoominzoomoutflag)
    }

    //zoomout modal fn
    const zoomoutFunction = () => {
        let zoominzoomoutflag = ""
        setZoominzoomoutflag(zoominzoomoutflag)
    }

    //delete support user fn
    const deleteSupportUserFn = (params) => {
        setDeleteConfirmationAlertModal(true)
        setDeleteBodySecondContent(params.data.name)
        setHotelDeleteObj(params.data)
    }

    //delete support user confirmaion modal close fn
    const deleteConfirmationModalHide = () => {
        setDeleteConfirmationAlertModal(false)
        setDeleteBodySecondContent("")
        setHotelDeleteObj({})
    }

    //delete support user confirmaion modal confirm fn
    const deleteConfirmButton = () => {
        hotelDeleteFn()
    }

    //delete support user confirmaion modal cancel fn
    const deleteCancleButton = () => {
        deleteConfirmationModalHide();
    }

    //support user delete api fn
    const hotelDeleteFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        let data = {}
        data['id'] = [hotelDeleteObj.id]
    }

    //view business list modal close fn
    const closeViewBusnessListModalFn = () => {
        setViewBusnessListModal(false);
        setZoominzoomoutflag("")
    }

    //audit history modal open fn
    const auditHistoryFn = (params) => {
        setSupportUserId(params.data.id);
        setAuditHistoryModalFlag(true);
    }

    return (
        <div className="gridcontainer supportUserContainer">
            <div className="totalworkercontent">
                <div className="gridtopviews gridtopviewsHistory gridtopviewsAllSection">
                    <div className="rightboxes">
                        {/* <CustomButton
                            onClick={auditHistoryModalFn}
                            className="customButtonClass"
                            children="Audit History"
                        /> */}
                        <CustomButton
                            onClick={createSupportUserModalFn}
                            className="customButtonClass"
                            children="Add Support User"
                        />
                    </div>
                </div>
                <div className='filterSection filterSectionBox'>
                    <div className="gridtopviews gridtopviewsHistory">
                        <div className="dropdownbox dropdownBoxContainer statusdropcontainer">
                            <AutosuggestComponent
                                handleOnChange={(e) => { handleChangeUserFilter('status', e) }}
                                options={statusList}
                                selectedValue={selectedStatus}
                                name=''
                                isMulti={false}
                                placeholder="Status"
                                isDisabled={false}
                                isClearable={true}
                                closeButton={false}
                                menuHeader="Status"
                                isSearchable={true}
                                openMenu={true}
                            />
                        </div>
                        <form id="hotel">
                            <div className="pageinnersearchBox hotel">
                                <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                                <DebounceInput
                                    minLength={2}
                                    debounceTimeout={500}
                                    onChange={(e) => handleSearchValue(e)}
                                    placeholder="Name/Email/Phone Number"
                                    value={searchUserName}
                                    autoComplete="off"
                                />
                                {searchUserName != "" ?
                                    < button type="button" className="btn btn-link dropclosebtn"
                                        onClick={clearSearchValue}
                                    >
                                        <img src={require('../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                                    </button>
                                    : null}
                            </div>
                        </form>
                    </div>
                </div>
                <div className='grid_content_inner'>
                    <div className="ag-theme-alpine aggridviewSection" style={{ position: 'relative' }}>
                        <div className="leadButtonInner"><button className="buttonload" onClick={() => { loadGrid() }} data-tip="Refresh"><RefreshButton
                            isAnimating={isAnimating}
                        />
                        </button>
                            <ReactTooltip place="bottom" />
                        </div>
                        <AgGridReact
                            modules={modules}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            components={components}
                            rowSelection="single"
                            rowModelType="infinite"
                            onGridReady={onGridReady}
                            rowHeight={43.9}
                            headerHeight={40.8}
                            cacheBlockSize={"10"}
                            gridOptions={gridOptions}
                            noRowsOverlayComponent={noRowsOverlayComponent}
                            ref={gridRef}
                        />
                    </div>
                </div>
            </div>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={supportUserCreateModalFlag}
                    onHide={closeSupportUserModal}
                    title={supportUserModalTitle}
                    className={` ${zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension supportUserModal addSupportUserModal"}`}
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    zoominButton={zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={zoominzoomoutflag != "" ? true : false}
                    zoomin={zoominFunction}
                    zoomout={zoomoutFunction}

                    body={
                        <>
                            <ErrorBoundary title="AddSupportUserModalContent Error">
                                <AddSupportUserModalContent
                                    editedFlag={editedUserFlag}
                                    editRowData={editRowData}
                                    closeSupportUserModal={closeSupportUserModal}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={viewBusnessListModal}
                    onHide={closeViewBusnessListModalFn}
                    title={'Assign Business List'}
                    className="modalcustomizeDialog mondimension supportUserModal viewBusinessListModal"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    body={
                        <>
                            <ErrorBoundary title="viewBusinessListModal Error">
                                <ViewBusinessDetailsModalContent
                                    supportUserId={supportUserId}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
            {actionModalflag ?
                <>
                    <ErrorBoundary title="GridActionContent Error">
                        <GridActionContent
                            styleWidth={overlayWidth}
                            styleHight={overlayHight}
                            codeOutsideClickRef={actionOutsideClickRef}
                            gridObjData={gridObjData}
                            modefier={editSupportUserFn}
                            delete={deleteSupportUserFn}
                            editButtonShow={gridObjData.data.is_active ? true : false}
                            deleteButtonShow={false}
                            auditHistoryShow={false}
                            auditHistoryFn={auditHistoryFn}
                        />
                    </ErrorBoundary>
                </>
                : null}

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={deleteConfirmationAlertModal}
                    onHide={deleteConfirmationModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Delete This Support User?"
                    footer={false}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Do you confirm the deletion of the"
                                    BodySecondContent={deleteBodySecondContent}
                                    BodyThirdContent="support user definitely? You won't be able to go back."
                                    confirmationButtonContent="confirm"
                                    cancelButtonContent="cancel"
                                    deleteConfirmButton={deleteConfirmButton}
                                    deleteCancleButton={deleteCancleButton}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={auditHistoryModalFlag}
                    onHide={auditHistoryModalHide}
                    title="Audit History"
                    className="modalcustomizeDialog mondimension supportUserModal addSupportUserModal"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    body={
                        <>
                            <ErrorBoundary title="AuditHistoryModalContent Error">
                                <AuditHistoryModalContent
                                    supportUserId={Number(supportUserId) != 0 ? [supportUserId] : []}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

        </div>
    );
};

SupportUser.defaultProps = {
    hotelFilterShow: true
}
const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}


export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(SupportUser));
